module.exports = __webpack_public_path__ + "static/Kaizen_Corp_Centralizacao-37634957b7903c3ebce888bcac3729d9.jpg";